/*
 * Copyright (c) 2020.
 * Simon
 */

import {FANPAGE_CREATE_SUCCESS, FANPAGE_DETAIL_SUCCESS, FANPAGE_LIST_SUCCESS,FANPAGE_GET_ALL_SUCCESS} from "../../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const FanpagesReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case FANPAGE_LIST_SUCCESS:
            let fanpages = action.payload.data.data;

            fanpages.map((fanpage) => {
                let id = fanpage['page_id'];
                state[id] = fanpage;
                return true;
            });

            return {...state, action};
        case FANPAGE_GET_ALL_SUCCESS:
            return {...state, action};
        case FANPAGE_DETAIL_SUCCESS:
        case FANPAGE_CREATE_SUCCESS:
            let id = action.payload.data['page_id'];
            state[id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {FanpagesReducer}